<template>
  <div>
    <section class="main" v-if="Product">
      <div class="container">
        <div class="img-box">
          <img :src="SiteUrl + Product.Image" alt="" />
        </div>
        <div class="box">
          <!-- 0517 新增 title-box div -->
          <div class="title-box">
            <h1>{{ Product.Name }}</h1>
            <div style="display: flex">
              <img
                v-if="Product.IconMRT"
                src="img/icon_MRT.png"
                alt=""
                style="margin-right: 5px; width: 32px; height: 32px"
              />
              <img
                v-if="Product.IconLightRail"
                src="img/icon_LightRail.png"
                alt=""
                style="margin-right: 5px; width: 32px; height: 32px"
              />
              <img
                v-if="Product.IconBus"
                src="img/icon_Bus.png"
                alt=""
                style="margin-right: 5px; width: 32px; height: 32px"
              />
              <img
                v-if="Product.IconBicycle"
                src="img/icon_Bicycle.png"
                alt=""
                style="margin-right: 5px; width: 32px; height: 32px"
              />
              <img
                v-if="Product.IconFerry"
                src="img/icon_Ferry.png"
                alt=""
                style="margin-right: 5px; width: 32px; height: 32px"
              />
            </div>
            <div class="price">
              <p v-if="Product.OriginalPrice > 0">
                NTD{{ Product.OriginalPrice }}
              </p>
              <p v-if="Product.OriginalPrice == 0"></p>
              <p>NTD</p>
              <p>{{ Product.Price }}</p>
            </div>
          </div>
          <hr />
          <!-- 0517 新增 text-box div -->
          <div class="text-box">
            <!-- 0517 新增 h2 -->
            <h2>{{ $t("方案內容") }}</h2>
            <p class="text" v-html="Product.Content"></p>
            <hr />
            <div class="btn-box" v-if="IsLogin">
              <!-- 0518 增加 onclick -->
              <router-link
                :to="{ name: 'ProductBuy', params: { PRId: Product.PRId } }"
                tag="button"
              >
                {{ $t("立即購買") }}
              </router-link>
            </div>
            <div class="btn-box" v-if="!IsLogin">
              <!-- 0518 增加 onclick -->
              <router-link :to="{ name: 'Login' }" tag="button">
                {{ $t("請先登入") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "方案內容": "方案內容",
    "立即購買": "立即購買",
    "請先登入": "請先登入",
  },
  en: {
    "方案內容": "Content",
    "立即購買": "Buy now",
    "請先登入": "Please log in",
  },
  jp: {
    "方案內容": "プラン内容",
    "立即購買": "今すぐ買う",
    "請先登入": "先にログインする",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "MProduct",
  i18n,
  data() {
    return {
      SiteUrl: "",
      Product: {},
      IsLogin: Storage.isKey("ek_login_token"),
    };
  },
  created: function () {
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Product", {
        params: { PRId: this.$route.params.PRId },
      })
      .then((response) => {
        this.SiteUrl = response.data.SiteUrl;
        this.Product = response.data.Product;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("package-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Product.vue